import {Pipe, PipeTransform} from '@angular/core';
import {ProjectService} from '../../services/project/project.service';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'convertLocationId',
  pure: false,
})


export class ConvertLocationIdPipe implements PipeTransform {

  cacheId: number;
  cacheName: '';

  constructor(private projectService: ProjectService) {
  }

  transform(locationId: number, args?: any): any {
    if (locationId !== this.cacheId) {
      this.cacheId = locationId;
      this.cacheName = '';
      this.convertIdToName(locationId);
    }
    return this.cacheName;
  }

  convertIdToName(value: number) {
    this.projectService.getProjectDeviceLocation(value).pipe(map((data: any) => data.name)).subscribe(
      (result) => {
        this.cacheName = result;
      }
    );
  }
}

